import styled from "styled-components/macro";

export const StyledRightForm = styled.div`
	padding: 1.6rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(110.71deg, #262f69 -3.16%, #6270c6 107.12%);
`;

export const PoweredBy = styled.p`
    display: flex;
    justify-content: center;
    color #6270C6;
    font-size: 12px;
    line-height: 18px;
`;

export const PurchaseButton = styled.button`
	background: #6270c6;
	color: #ffffff;
	border-radius: 2px;
	padding: 10px 14px;
	border: none;
	cursor: pointer;
	width: 100%;
	margin: 10px 0;
`;

export const CardElementContainer = styled.div`
	background: #f5f5f5;
	border: 1px solid #dbdbdb;
	box-sizing: border-box;
	border-radius: 2.03125px;
	padding: 0.6rem;
	width: 100%;
	margin-bottom: 0.8rem;
`;

export const Terms = styled.div`
	margin-top: 10px;
	font-size: 14px;
`;
